import { Image, Text } from '@dsx/react';
import {
	Footer as DsFooter,
	FooterLinkGroup,
	FooterSection,
	FooterSectionGroup,
	SocialLinks,
	LegalLinks,
	TrackingLink,
} from '@ds-mgnl/marketing';
import footerLogo from '../../assets/images/ds-logo.svg';
import styles from './Footer.module.css';

export const Footer = () => {
	const currentYear = new Date().getFullYear();
	const copyright = `©2009-${currentYear} Direct Supply, Inc. All rights reserved.`;

	return (
		<div className={styles['footer-container']}>
			<DsFooter
				header={
					<TrackingLink
						href="/"
						clickType="footer_link"
						trackingText="Footer Logo"
					>
						<Image
							src={footerLogo}
							alt="DS TELS Logo"
							loading="lazy"
							width="187px"
							height="64px"
						/>
					</TrackingLink>
				}
				subFooter={
					<LegalLinks
						links={[
							{
								children: 'Application Privacy & Legal Information',
								href: '/legal/application-privacy',
							},
							{
								children: 'Terms of Use',
								href: '/legal/terms-of-use',
							},
							{
								children: 'Privacy Policy',
								href: '/legal/privacy-policy',
							},
							{
								children: 'Cookie Policy',
								href: '/legal/cookie-policy',
							},
							{
								children: 'California Collection Notice',
								href: '/legal/privacy-policy#california-collection-notice',
							},
						]}
						copyrightText={copyright}
					/>
				}
			>
				<FooterSectionGroup key="contact-social">
					<FooterSection title="Contact us" columnCount={1} columnWidth="260px">
						<div>
							<Text variant="body-small">Need help or have a question?</Text>
							<TrackingLink
								href="/contact/"
								size="small"
								linkStyle="standalone"
								actionIndicator="MdArrowForward"
								clickType="footer_link"
							>
								Contact us
							</TrackingLink>
						</div>
					</FooterSection>
					<SocialLinks
						links={[
							{
								href: 'https://www.facebook.com/directsupply',
								site: 'facebook',
							},
							{
								href: 'https://twitter.com/_DirectSupply',
								site: 'twitterX',
							},
							{
								href: 'http://www.linkedin.com/company/direct-supply',
								site: 'linkedin',
							},
							{
								href: 'http://www.youtube.com/c/directsupply',
								site: 'youtube',
							},
						]}
					/>
				</FooterSectionGroup>

				<FooterSection
					key="solutions"
					title="Solutions"
					columnCount={1}
					columnWidth="260px"
				>
					<FooterLinkGroup
						links={[
							{ href: '/solutions/advocacy', children: 'Advocacy' },
							{
								href: '/solutions/building-maintenance',
								children: 'Building Maintenance',
							},
							{
								href: '/solutions/design-procurement',
								children: 'Design & Procurement',
							},
							{
								href: '/solutions/equipment-furnishings',
								children: 'Equipment & Furnishings',
							},
							{
								href: '/solutions/professional-services',
								children: 'Professional Services',
							},
							{
								href: '/solutions/spend-management',
								children: 'Spend Management',
							},
							{
								href: '/solutions/workforce-technology',
								children: 'Workforce Technology',
							},
						]}
					/>
				</FooterSection>

				<FooterSection
					key="resources"
					title="Resources"
					columnCount={1}
					columnWidth="260px"
				>
					<FooterLinkGroup
						links={[
							{ href: '/resources/blogs', children: 'Blog' },
							{ href: '/resources/case-studies', children: 'Case Studies' },
							{
								href: '/resources/maintenance-guides',
								children: 'Maintenance Guides',
							},
							{
								href: '/resources/selection-guides',
								children: 'Selection Guides',
							},
							{ href: '/resources/webinars', children: 'Webinars' },
							{
								href: '/resources/white-papers',
								children: 'White Papers',
							},
						]}
					/>

					<FooterLinkGroup
						links={[{ href: '/resources', children: 'View all resources' }]}
					/>
				</FooterSection>
				<FooterSection
					key="company"
					title="Company"
					columnCount={1}
					columnWidth="260px"
				>
					<FooterLinkGroup
						links={[
							{ href: '/company/about', children: 'About' },
							{ href: '/company/careers', children: 'Careers' },
							{ href: '/company/innovation', children: 'Innovation' },
							{ href: '/company/internships', children: 'Internships' },
							{ href: '/events', children: 'Events' },
							{ href: '/contact', children: 'Contact us' },
						]}
					/>
				</FooterSection>
			</DsFooter>
		</div>
	);
};
